"use client";

import { isPreviewing } from "@builder.io/sdk-react";
import Script from "next/script";

import type { CookieBannerData } from "@/libs/builder/validators/isCookieBannerData";

export const CookieBanner = ({ cookieKey, cookieScriptUrl, isCookieMultiLanguage }: CookieBannerData) => {
  if (isPreviewing()) return null;

  return (
    cookieKey && (
      <>
        <Script
          src={cookieScriptUrl}
          data-domain-script={cookieKey}
          data-document-language={isCookieMultiLanguage ? "true" : "false"}
          defer
          strategy="afterInteractive"
        />
        <Script id="one-trust-optanonWrapper" type="text/javascript" strategy="afterInteractive">
          {`function OptanonWrapper() {}`}
        </Script>
      </>
    )
  );
};
